import { triggerTracking } from '@zoopla/tracking';
import { AnalyticsEcommerceImpression } from '@zoopla/listing-search-context';
import { GATrackingContract } from '@zoopla/tracking';

export const ecommerceClickTracking = (
    productImpression: AnalyticsEcommerceImpression,
    listName = 'Search results'
) => {
    triggerTracking({
        event: 'GAEventEcommerce',
        ecommerce: {
            click: {
                actionField: {
                    list: listName
                },
                products: [
                    {
                        id: productImpression.id,
                        variant: productImpression.variant,
                        position: productImpression.position
                    }
                ]
            }
        }
    });
};

export const ecommerceImpressionTracking = (ecommerce: GATrackingContract) => {
    triggerTracking({
        event: 'GAEventEcommerce',
        ...ecommerce
    });
};

export const developmentTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'clickthrough',
        eventLabel: 'see_all_properties_link'
    });
};
